import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getActiveSchoolYears,
} from '../../services/activeSchoolYears.service';

export const fetchActiveSchoolYears = createAsyncThunk(
  'input/fetchActiveSchoolYears',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      string[]
    >(
      thunkAPI,
      getActiveSchoolYears( { signal: thunkAPI.signal })
    );
  }
);
